import {createAction} from 'redux-actions'
import {COPY2PAYLOAD, SECURITY, MORE_STORE, SILENT} from 'uix/actions'

// check webauthn support for username
export let queryWebauthn = createAction('QUERY_WEBAUTHN', username => ({username}))

// begin webauthn registration
export let beginWebauthn = createAction('BEGIN_WEBAUTHN', (user, options) => ({
  user,
  options: options || {},
}))
// store new data to meta.webauth
export let setWebauthn = createAction('SET_WEBAUTHN', COPY2PAYLOAD)

// begin webauth login procedure
export let loginWebauthn = createAction('LOGIN_WEBAUTHN', username => ({username}))

// run login saga and fetch new user state from server
export let runLogin = createAction(
  'RUN_LOGIN',
  ({username, password}) => ({username, password}),
  SECURITY
)
// run logout on server and retrieve new user state
export let runLogout = createAction('RUN_LOGOUT', reason => ({reason}))
export let runImpersonify = createAction('RUN_IMPERSONIFY', user => ({user}))

export let loginSuccess = createAction('LOGIN_SUCCESS', COPY2PAYLOAD, MORE_STORE(['config']))
export let loginFailed = createAction('LOGIN_FAILED', (username, reason) => ({username, reason}))

// set new user state
export let setUser = createAction('SET_USER', ({user}) => ({user}))

// retrieve data for puids
export const getUserData = createAction('GET_USER_DATA', ({puids, puid}) => ({puids, puid}), SILENT)
export const setUserData = createAction('SET_USER_DATA', COPY2PAYLOAD)
